<div class="container">
  <div class="layers">
    <span class="layer-text" [ngStyle]="{ width: labelWidth }"
      >{{ label }}:</span
    >
    <div
      class="tooltip"
      [ngStyle]="{ visibility: showTooltip ? 'visible' : 'hidden' }"
    >
      <div class="layer-info">?</div>
      <span class="tooltiptext"
        >An item in a higher-numbered layer is hidden by any item with a
        lower-numbered layer, The base video is usually the highest number
        layer, 60.
      </span>
    </div>
    <div class="layer-input-warpper">
      <input
        class="layer-input"
        type="number"
        min="{{ minNumber }}"
        max="{{ maxNumber }}"
        pattern="{{ pattern }}"
        (change)="zIndexChangeEventHandler($event)"
        [valueAsNumber]="zIndex"
      />
      <span class="type-layer">{{ shortLabel }}</span>
    </div>
  </div>
</div>
